//Moon.js
class Moon {
	static __starId = 0;
	static stars = [];
	static addStar = star => {
		star.__starId = Moon.__getStarId();
		star.__starStates = [];
		let keys = Object.keys(star.state);
		keys.forEach(key => {
			if (
				star.state[key] !== null &&
				typeof star.state[key] === "object" &&
				"_starState" in star.state[key]
			) {
				star.__starStates.push(key);
				if (star.state[key].value == "__MoonState")
					star.state[key] = Moon.getState(key);
				else star.state[key] = star.state[key].value;
			}
		});
		let componentWillUnmount = star.componentWillUnmount;
		star.componentWillUnmount = () => {
			if (star != null) {
				if (componentWillUnmount) componentWillUnmount.bind(star)();
				Moon.__removeStar(star.__starId);
			}
		};
		const setState = star.setState;
		star.setState = (partialState, callback, updateMoon = true) => {
			if (star != null) {
				setState.bind(star)(partialState, callback);
				if (updateMoon) Moon.setState(star, partialState);
			}
		};
		Moon.stars.push(star);
	};

	static setState = (starCaller, state) => {
		let keys = Object.keys(state);
		const stars = Moon.stars.filter(
			star =>
				starCaller.__starId != star.__starId &&
				star.__starStates.some(key => {
					return keys.includes(key);
				})
		);
		stars.forEach(star => {
			let newState = {};
			keys.forEach(key => {
				if (star.__starStates.includes(key)) newState[key] = state[key];
			});
			star.setState(newState, null, false);
		});
	};

	static use = (value = "__MoonState") => {
		return { value: value, _starState: true };
	};

	static getState = (key, defaultValue = null) => {
		let star = Moon.stars.find(star => {
			return star.__starStates.includes(key);
		});
		if (star != null) return star.state[key];
		return defaultValue;
	};

	static __removeStar = starId => {
		Moon.stars = Moon.stars.filter(star => star.__starId !== starId);
	};

	static __getStarId = () => {
		const id = Moon.__starId;
		Moon.__starId++;
		return id;
	};
}

export default Moon;
